import {
  fields
} from './cancelHelpers';
import {
  untouch,
  touch
} from 'redux-form';

export * from './cancelHelpers';

export const LOAD_CONTENT = 'hg/cancel/LOAD_CONTENT';
export const DISCONNECT_CUSTOMER = 'hg/cancel/DISCONNECT_CUSTOMER';
export const DL_PAGE_LOADED = 'hg/cancel/DL_PAGE_LOADED';

const initialState = {
  loaded: false,
  content: {}
};

export const cancel = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export const disconnectCustomer = () => {
  return {
    type: DISCONNECT_CUSTOMER
  };
};

export const touchFields = () => {
  return (dispatch) => {
    dispatch(untouch('cancel', ...fields));
    dispatch(touch('cancel', ...fields));
  };
};

export default cancel;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/cancel/cancel.js
 **/